import { API_URL, CUSTOMERS_KEY } from "../keys"
import axios from "axios"

export const createCustomerImage = async (customerId: string, file: File, token: string) => {
    const formData = new FormData()
    formData.append("files", file)

    const response = await axios.patch(
        `${API_URL}/customers/images/created/${customerId}`,
        formData,
        {
            headers: {
                "sce-api-key": CUSTOMERS_KEY,
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            },
            validateStatus: (status) => status < 500,
        }
    )
    if (response) return response
}

export const deleteCustomerImage = async (customerId: string, imageId: string, token: string) => {
    console.log({
        customerId,
        imageId,
        token,
        headers: {
            "sce-api-key": CUSTOMERS_KEY,
            Authorization: `Bearer ${token}`,
        }
    })
    const response = await axios.delete(`${API_URL}/customers/images/delete`, {
        headers: {
            "sce-api-key": CUSTOMERS_KEY,
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
        params: { customerId, imageId },
        validateStatus: (status) => status < 500,
    })
    if (response) return response
}

export const updateCustomer = async (id: string, data: any, token: string) => {
    const response = await axios.patch(`${API_URL}/customers/${id}`, data, {
        headers: {
            "sce-api-key": CUSTOMERS_KEY,
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
        validateStatus: (status) => status < 500,
    })
    if (response) return response
}


export const createCustomerAddress = async (customerId: string, data: any, token: string) => {
    const response = await axios.patch(
        `${API_URL}/customers/address/created/${customerId}`,
        data,
        {
            headers: {
                "sce-api-key": CUSTOMERS_KEY,
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            validateStatus: (status) => status < 500,
        }
    )
    if (response) return response
}

export const updateCustomerAddress = async (
    customerId: string,
    addressId: string,
    data: any,
    token: string
) => {
    const response = await axios.patch(`${API_URL}/customers/address/updated`, data, {
        headers: {
            "sce-api-key": CUSTOMERS_KEY,
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
        params: { customerId, addressId },
        validateStatus: (status) => status < 500,
    })
    if (response) return response
}

export const deleteCustomerAddress = async (customerId: string, addressId: string, token: string) => {
    const response = await axios.delete(`${API_URL}/customers`, {
        headers: {
            "sce-api-key": CUSTOMERS_KEY,
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
        params: { customerId, addressId },
        validateStatus: (status) => status < 500,
    })
    if (response) return response
}

export const createProductRaiting = async (
    productId: string,
    data: any,
    token: string
) => {
    const response = await axios.patch(
        `${API_URL}/products/raitings/created/${productId}`,
        data,
        {
            headers: {
                "sce-api-key": CUSTOMERS_KEY,
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            validateStatus: (status) => status < 500,
        }
    )
    if (response) return response
}

export const verifyProductRaiting = async (
    customerId: string,
    productId: string,
    token: string
) => {
    const response = await axios.get(`${API_URL}/products/raitings/verify/raithing`, {
        headers: {
            "sce-api-key": CUSTOMERS_KEY,
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
        params: { customerId, productId },
        validateStatus: (status) => status < 500,
    })
    if (response) return response
}